

























































































































































































































































































































































import Vue from 'vue'
// @ts-ignore
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  DxTreeList,
  DxColumn,
  DxColumnChooser,
  DxHeaderFilter,
  DxSearchPanel,
  DxSelection,
  DxLookup,
  DxSorting,
  DxFilterRow,
  DxStateStoring,
  DxScrolling,
  DxRowDragging
} from 'devextreme-vue/tree-list';
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { ProductSearchRecord } from '@/model/products/ProductSearchRecord'
import { KeyAction } from '@/model/KeyAction'
import { Pane, Splitpanes } from 'splitpanes'
import { UiLanguageItem, UiLanguageList } from '@/types'
import ProductTextLanguagesDialog from '@/components/master-data/product/ProductTextLanguagesDialog.vue'
import ProductSearchDialog from '@/components/master-data/product/ProductSearchDialog.vue'
import {
  DELETE_PRODUCT_PARTS_LIST, DELETE_PRODUCT_PARTS_LIST_COMPONENT,
  FETCH_PRODUCT_PARTS_LIST_BY_PRODUCT_ID, FETCH_PRODUCT_PARTS_LIST_COMPONENTS,
  FETCH_PRODUCT_PARTS_LIST_DATA, UPSERT_PRODUCT_PARTS_LIST, UPSERT_PRODUCT_PARTS_LIST_COMPONENT
} from '@/store/action-types'
import {
  DeleteStuecklistenKomponentenPayload,
  UpsertStuecklistenKomponentenPayload,
  UpsertStueckListePayload
} from '@/types/payload'
import {
  ProjectPatsListComponentsResponse,
  ProjectPatsListMetadataResponse,
  ProjectPatsListResponse,
  StuecklistResponse,
} from '@/types/service-response'

interface ComponentData {
  tableHeight: string
  sectionHeight: string
  pane1Size: number
  pane2Size: number
  pane2Width: number
  isSplitterOpen: boolean

  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  rules: any[]

  activeTab: number
  isEdit: boolean
  isCreate: boolean
  formIsValid1: boolean
  formIsValid2: boolean
  isSaveInProgressVariant: boolean
  isSaveInProgressComponent: boolean
  showSearchDialog: boolean
  foundProduct: ProductSearchRecord | null

  selectedVariantIndex: number
  selectedVariant: StuecklistResponse | null
  gridData: any[]
  selectedRowIndex: number
  selectedRow: any | null

  artList: any[]
  variantList: any[]
  druckCodeList: any[]
  preisCodeList: any[]
  druckCodeVorgabeList: any[]
  preisCodeVorgabeList: any[]
  positionArtList: any[]
  einheitList: any[]

  varianteBevorzugt: boolean
  art: number | null
  variante: number | null
  druckCode: number | null
  preisCode: number | null
  druckCodeVorgabe: number | null
  preisCodeVorgabe: number | null

  positiontyp: number | null
  positionArt: number | null
  beinhaltet: number | null
  beinhaltetVariante: number | null
  zeile: number | null
  menge: string | null //double
  mengeVariabel: boolean
  einheit: number | null
  minimalMenge: string | null //double
  einrichtMenge: string | null //double
  auswahlCode: string | null
  ausschussfaktor: string | null //double
  rundung: string | null //double
  preisCodeComponent: number | null
  druckCodeComponent: number | null
  seitenumbruch: boolean
  gliederungsNummer: string | null
  text: string | null
  text2: string | null

  showLanguages1Dialog: boolean
  showLanguages2Dialog: boolean
  languages1: any[]
  languages2: any[]

  keyActions: KeyAction[]
  partsList: StuecklistResponse[]
  typeList: any[]
}

export default Vue.extend({
  name: 'ProductPartsList',

  components: {
    DxTreeList,
    DxColumn,
    DxColumnChooser,
    DxHeaderFilter,
    DxSearchPanel,
    DxSelection,
    DxLookup,
    DxSorting,
    DxFilterRow,
    DxStateStoring,
    DxScrolling,
    DxRowDragging,
    Splitpanes,
    Pane,
    ProductTextLanguagesDialog,
    ProductSearchDialog
  },

  props: {
    productId: Number,
    selectedProduct: Object as () => ProductSearchRecord
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      sectionHeight: '',
      pane1Size: 100,
      pane2Size: 0,
      pane2Width: 50,
      isSplitterOpen: false,

      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      rules: [(value: any): boolean | string => value !== null || ''],

      activeTab: 1,
      isEdit: false,
      isCreate: false,
      formIsValid1: false,
      formIsValid2: false,
      isSaveInProgressVariant: false,
      isSaveInProgressComponent: false,
      showSearchDialog: false,
      foundProduct: null,

      selectedVariantIndex: 0,
      selectedVariant: null,
      gridData: [],
      selectedRowIndex: 0,
      selectedRow: null,

      artList: [],
      variantList:[],
      druckCodeList: [],
      preisCodeList: [],
      druckCodeVorgabeList: [],
      preisCodeVorgabeList: [],
      positionArtList: [],
      einheitList: [],

      varianteBevorzugt: false,
      art: null,
      variante: null,
      druckCode: null,
      preisCode: null,
      druckCodeVorgabe: null,
      preisCodeVorgabe: null,

      positiontyp: null,
      positionArt: null,
      beinhaltet: null,
      beinhaltetVariante: null,
      zeile: null,
      menge: null,
      mengeVariabel: false,
      einheit: null,
      minimalMenge: null,
      einrichtMenge: null,
      auswahlCode: null,
      ausschussfaktor: null,
      rundung: null,
      preisCodeComponent: null,
      druckCodeComponent: null,
      seitenumbruch: false,
      gliederungsNummer: null,
      text: null,
      text2: null,

      showLanguages1Dialog: false,
      showLanguages2Dialog: false,
      languages1: [],
      languages2: [],

      keyActions: [],
      partsList: [],
      typeList: [{id: 1, label: 'Typ 1'}, {id: 2, label: 'Typ 2'}],
    }
  },

  watch: {
    productId (newVal: number): void {
      console.log(newVal)
      if(newVal && newVal !== 0) {
        this.isCreate = false
        this.isEdit = false
        this.selectedVariantIndex = 0
        this.selectedVariant = null
        this.partsList = []
        this.gridData = []
        this.setEmptyVariantForm()
        this.setEmptyComponentForm()
        this.fetchVariantData()
      }
    },

    activeTab (newVal: number): void {
      this.isCreate = false
      this.isEdit = false
      this.setVariantForm()
      this.setComponentForm()
    },

    selectedVariant (newVal: any): void {
      this.isCreate = false
      this.isEdit = false
      if(newVal) {
        this.fetchPartsListComponents()
      }
    },

    selectedRow (newVal: any): void {
      this.isCreate = false
      this.isEdit = false
      if(newVal) {
        this.setComponentForm()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isBeforeDisabled (): boolean {
      return this.selectedRowIndex === 0
    },

    isAfterDisabled (): boolean {
      return this.selectedRowIndex === this.gridData.length -1
    },

    isUpDisabled (): boolean {
      return true
    },

    isDownDisabled (): boolean {
      return true
    },

    isDisabledInsertButton (): boolean {
      return false
    },

    isDisabledUpdateButton (): boolean {
      return false
    },

    isDisabledDeleteButton (): boolean {
      return false
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguage (): UiLanguageItem {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE]
    },

    /*filteredVariantList (): VarianteResponse[] {
      return this.variantList.filter((item: VarianteResponse) => item.Sprache === this.selectedLanguage.syzId)
    }*/
  },

  methods: {
    getVariantName (variant: number): string[] {
      const foundVariant: any | undefined = this.variantList.find((item: any) => item.Wert === variant)
      return foundVariant ? foundVariant.Bezeichnung : ''
    },

    onCreateClick (): void {
      if(this.activeTab === 0) {
        this.setEmptyVariantForm()
        this.isCreate = true
        this.isEdit = true
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField1']
          if (focusedField) {
            focusedField.focus()
          }
        }, 100)
      } else if(this.activeTab === 1 && this.selectedVariant) {
        this.setEmptyComponentForm()
        this.isCreate = true
        this.isEdit = true
        //this.showSearchDialog = true
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField2']
          if (focusedField) {
            focusedField.focus()
          }
        }, 100)
      }
    },

    onSelectedProduct (data: ProductSearchRecord): void {
      this.showSearchDialog = false
      this.foundProduct = data
      this.isEdit = true
      this.$nextTick(() => {
        const focusedField: any = this.$refs['focusedField2']
        if (focusedField) {
          focusedField.focus()
        }
      })
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    onUpdateClick (): void {
      this.isEdit = true
      if(this.activeTab === 0) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField1']
          if (focusedField) {
            focusedField.focus()
          }
        }, 100)
      } else if(this.activeTab === 1) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField2']
          if (focusedField) {
            focusedField.focus()
          }
        }, 100)
      }
    },

    onDeleteClick (): void {
      if(this.activeTab === 0 && this.selectedVariant) {
        this.deletePartsList()
      } else if(this.activeTab === 1 && this.selectedRow) {
        this.deletePartsListComponent()
      }
    },

    onBeforeClick (): void {
      this.isEdit = false
      this.selectedRowIndex -= 1
      this.selectedRow = this.gridData[this.selectedRowIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.gridData[this.selectedRowIndex].ID])
    },

    onAfterClick (): void {
      this.isEdit = false
      this.selectedRowIndex += 1
      this.selectedRow = this.gridData[this.selectedRowIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.gridData[this.selectedRowIndex].ID])
    },

    onUpClick (): void {

    },

    onDownClick (): void {

    },

    onCopyClick (): void {

    },

    onSaveButtonClick (): void {
      const form1: any = this.$refs['form1']
      const form2: any = this.$refs['form2']
      if(this.activeTab === 0) {
        if (this.formIsValid1 && form1.validate()) {
          this.upsertPartsList()
        }
      } else if(this.activeTab === 1) {
        if (this.formIsValid2 && form2.validate()) {
          this.upsertPartsListComponent()
        }
      }
    },

    onCancelVariantClick (): void {
      this.isCreate = false
      this.isEdit = false
      const form1: any = this.$refs['form1']
      if(form1) {
        form1.resetValidation()
      }
      this.setVariantForm()
    },

    onCancelComponentClick (): void {
      this.isCreate = false
      this.isEdit = false
      const form2: any = this.$refs['form2']
      if(form2) {
        form2.resetValidation()
      }
      this.setComponentForm()
    },

    splitterDoubleClick (e: any): void {
      if(this.isSplitterOpen) {
        setTimeout(() => {
          this.resizePane()
        }, 0)
      } else {
        setTimeout(() => {
          this.pane1Size = 100
          this.pane2Size = 0
        }, 0)
      }

      this.isSplitterOpen = !this.isSplitterOpen
    },

    resizePane (): void {
      this.pane2Size = this.pane2Width
      this.pane1Size = 100 - this.pane2Size
    },

    onLanguages1Click (): void {
      this.showLanguages1Dialog = true
    },

    onLanguages1DialogSave (): void {
      this.showLanguages1Dialog = false
    },

    onLanguages1DialogClose (): void {
      this.showLanguages1Dialog = false
    },

    onLanguages2Click (): void {
      this.showLanguages2Dialog = true
    },

    onLanguages2DialogSave (): void {
      this.showLanguages2Dialog = false
    },

    onLanguages2DialogClose (): void {
      this.showLanguages2Dialog = false
    },

    onVariantClick (item: StuecklistResponse): void {
      this.selectedVariant = item
      this.setVariantForm()
    },

    onTypeChange (item: any): void {

    },

    onRowClick (data: any): void {
      const foundRow: any | undefined = this.gridData.find((item: any) => item.ID === data.data.ID)
      if(foundRow) {
        this.selectedRowIndex = this.gridData.indexOf(foundRow)
        this.selectedRow = foundRow
      }
    },

    onDragChange (e: any): void {
      const visibleRows = e.component.getVisibleRows();
      const sourceNode = e.component.getNodeByKey(e.itemData.id);
      let targetNode = visibleRows[e.toIndex].node;

      while (targetNode && targetNode.data) {
        if (targetNode.data.id === sourceNode.data.id) {
          e.cancel = true;
          break;
        }
        targetNode = targetNode.parent;
      }
    },

    onReorder (e: any): void {
      const visibleRows = e.component.getVisibleRows()

      if (e.dropInsideItem) {
        e.itemData.parentId = visibleRows[e.toIndex].key

        e.component.refresh()
      } else {
        const data = this.gridData.slice()
        const sourceData = e.itemData
        const toIndex = e.fromIndex > e.toIndex ? e.toIndex - 1 : e.toIndex
        let targetData = toIndex >= 0 ? visibleRows[toIndex].node.data : null

        if (targetData && e.component.isRowExpanded(targetData.id)) {
          sourceData.parentId = targetData.id
          targetData = null
        } else {
          sourceData.parentId = targetData ? targetData.parentId : null
        }

        const sourceIndex = this.gridData.indexOf(sourceData)
        data.splice(sourceIndex, 1)

        const targetIndex = this.gridData.indexOf(targetData) + 1
        data.splice(targetIndex, 0, sourceData)
        this.gridData = data
      }
    },

    setEmptyVariantForm (): void {
      this.varianteBevorzugt = false
      this.art = null
      this.variante = null
      this.druckCode = null
      this.preisCode = null
      this. druckCodeVorgabe = null
      this.preisCodeVorgabe = null

      const form1: any = this.$refs['form1']
      if(form1) {
        form1.resetValidation()
      }
    },

    setVariantForm (): void {
      if(!this.selectedVariant) {
        this.selectedVariant = this.partsList && this.partsList[0] ? this.partsList[0] : null
      }

      if(this.selectedVariant) {
        const selectedPartsList: StuecklistResponse | undefined = this.partsList.find((item: StuecklistResponse) => item.ID === this.selectedVariant!.ID)
        if(selectedPartsList) {
          this.varianteBevorzugt = selectedPartsList.VarianteBevorzugt
          this.art = selectedPartsList.Art
          this.variante = selectedPartsList.Variante
          this.druckCode = selectedPartsList.DruckCode
          this.preisCode = selectedPartsList.PreisCode
          this. druckCodeVorgabe = selectedPartsList.DruckCodeVorgabe
          this.preisCodeVorgabe = selectedPartsList.PreisCodeVorgabe
        }
      }
    },

    setEmptyComponentForm (): void {
      this.positiontyp = null
      this.seitenumbruch = false
      this.text = null
      this.text2 = null
      this.druckCodeComponent = null
      this.auswahlCode = null
      this.positionArt = null
      this.zeile = null
      this.gliederungsNummer = null
      this.menge = null
      this.mengeVariabel = false
      this.einheit = null
      this.minimalMenge = null
      this.einrichtMenge = null
      this.ausschussfaktor = null
      this.rundung = null
      this.preisCodeComponent = null

      const form2: any = this.$refs['form2']
      if(form2) {
        form2.resetValidation()
      }
    },

    setComponentForm (): void {
      this.positiontyp = this.selectedRow.PositionTyp
      this.seitenumbruch = this.selectedRow.Seitenumbruch
      this.text = this.selectedRow.PositionType
      this.text2 = this.selectedRow.PositionType
      this.druckCodeComponent = this.selectedRow.DruckCode
      this.auswahlCode = this.selectedRow.AuswahlCode
      this.positionArt = this.selectedRow.PositionArt
      this.zeile = this.selectedRow.Zeile
      this.gliederungsNummer = this.selectedRow.GliederungsNummer
      this.menge = this.selectedRow.Menge
      this.mengeVariabel = this.selectedRow.MengeVariabel
      this.einheit = this.selectedRow.Einheit
      this.minimalMenge = this.selectedRow.Minimalmenge
      this.einrichtMenge = this.selectedRow.EinrichtMenge
      this.ausschussfaktor = this.selectedRow.Ausschussfaktor
      this.rundung = this.selectedRow.Rundung
      this.preisCodeComponent = this.selectedRow.PreisCode
    },

    async upsertPartsListComponent (): Promise<void> {
      const payload: UpsertStuecklistenKomponentenPayload = {
        StuecklistenKomponente: this.isCreate ? 0 : this.selectedRow.ID,
        Stueckliste: this.selectedVariant!.ID,
        Positiontyp: this.positiontyp!,
        PositionArt: this.positionArt!,
        Beinhaltet: this.beinhaltet!,
        BeinhaltetVariante: this.beinhaltetVariante!,
        Zeile: this.zeile!,
        Menge: this.menge,
        MengeVariabel: this.mengeVariabel,
        Einheit: this.einheit!,
        MinimalMenge: this.minimalMenge,
        EinrichtMenge: this.einrichtMenge,
        AuswahlCode: this.auswahlCode,
        Ausschussfaktor: this.ausschussfaktor,
        Rundung: this.rundung,
        PreisCode: this.preisCodeComponent,
        DruckCode: this.druckCodeComponent,
        Seitenumbruch: this.seitenumbruch,
        GliederungsNummer: this.gliederungsNummer!,
      }

      this.isSaveInProgressComponent = true
      try {
        const response: any = await this.$store.dispatch(UPSERT_PRODUCT_PARTS_LIST_COMPONENT, payload)
        this.isSaveInProgressComponent = false
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchPartsListComponents()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        }
      } catch {
        this.isSaveInProgressComponent = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.isCreate = false
        this.isEdit = false
      }
    },

    async deletePartsListComponent (): Promise<void> {
      const payload: DeleteStuecklistenKomponentenPayload = {
        stuecklistenkomponente: this.selectedRow.ID,
        stuecklisteId: this.selectedVariant!.ID
      }

      try {
        const response: any = await this.$store.dispatch(DELETE_PRODUCT_PARTS_LIST_COMPONENT, payload)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.selectedVariant = null
          this.fetchPartsListComponents()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async upsertPartsList (): Promise<void> {
      const payload: UpsertStueckListePayload = {
        StueckList: this.isCreate ? 0 : this.selectedVariant!.ID,
        Produkt: this.productId,
        Art: this.art!,
        Variante: this.variante!,
        VarianteBevorzugt: this.varianteBevorzugt,
        DruckCode: this.druckCode!,
        PreisCode: this.preisCode!,
        PreisCodeVorgabe: this.preisCodeVorgabe!,
        DruckCodeVorgabe: this.druckCodeVorgabe!
      }

      this.isSaveInProgressVariant = true
      try {
        const response: any = await this.$store.dispatch(UPSERT_PRODUCT_PARTS_LIST, payload)
        this.isSaveInProgressVariant = false
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchVariantData()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        }
      } catch {
        this.isSaveInProgressVariant = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.isCreate = false
        this.isEdit = false
      }
    },

    async deletePartsList (): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(DELETE_PRODUCT_PARTS_LIST, this.selectedVariant!.ID)
        if(!response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.selectedVariant = null
          this.fetchVariantData()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchPartsListComponents (): Promise<void> {
      try {
        const response: ProjectPatsListComponentsResponse = await this.$store.dispatch(FETCH_PRODUCT_PARTS_LIST_COMPONENTS, this.selectedVariant!.ID)
        if(!response.IsError && response.Data) {
          this.gridData = response.Data
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }

        if(this.activeTab === 1 && this.gridData.length > 0) {
          this.selectedRow = this.gridData[this.selectedRowIndex]
          //@ts-ignore
          setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.selectedRow.ID])}, 0)
        }

      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchVariantData (): Promise<void> {
      try {
        const response: ProjectPatsListResponse = await this.$store.dispatch(FETCH_PRODUCT_PARTS_LIST_BY_PRODUCT_ID, this.productId)
        if(!response.IsError && response.Data) {
          this.partsList = response.Data.Stuecklist
          this.setVariantForm()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchMetaData (): Promise<void> {
      try {
        const response: ProjectPatsListMetadataResponse = await this.$store.dispatch(FETCH_PRODUCT_PARTS_LIST_DATA)
        if(!response.IsError && response.Data) {
          this.artList = response.Data.ds03
          this.variantList = response.Data.ds02
          this.druckCodeList = response.Data.ds04
          this.preisCodeList = response.Data.ds05
          this.druckCodeVorgabeList = response.Data.ds06
          this.preisCodeVorgabeList = response.Data.ds07
          this.positionArtList = response.Data.ds08
          this.einheitList = response.Data.ds09
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onResize (): void {
      if(this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          this.tableHeight = `height: calc(${vh}px - 280px)`
          this.sectionHeight = `height: calc(${vh}px - 232px)`
        } else {
          this.tableHeight = '252px'
          this.sectionHeight = '300px'
        }
      } else {
        this.tableHeight = '252px'
        this.sectionHeight = '300px'
      }

      setTimeout(() => {
        const splitpanes: any = this.$refs['splitpanes']
        this.pane2Width =  splitpanes ? (465 / splitpanes.$el.clientWidth) * 100 : 50
        this.resizePane()
      }, 0)
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguage.code)
  },

  mounted () {
    const splitter = document.getElementsByClassName("splitpanes__splitter")[0]
    if(splitter) {
      splitter!.addEventListener("dblclick", this.splitterDoubleClick)
    }

    this.fetchMetaData()
    this.fetchVariantData()

    this.languages1 = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })

    this.languages2 = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })
  },

  beforeDestroy (): void {
    const splitter = document.getElementsByClassName("splitpanes__splitter")[0]
    if(splitter) {
      splitter.removeEventListener("dblclick", this.splitterDoubleClick)
    }
  }

})
